import { render, staticRenderFns } from "./DetailBillHistory.vue?vue&type=template&id=58ffc4c5"
import script from "./DetailBillHistory.vue?vue&type=script&lang=js"
export * from "./DetailBillHistory.vue?vue&type=script&lang=js"
import style0 from "./DetailBillHistory.vue?vue&type=style&index=0&id=58ffc4c5&prod&lang=css"
import style1 from "./DetailBillHistory.vue?vue&type=style&index=1&id=58ffc4c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports